export default __webpack_public_path__ + "static/Avenir-Black-da68486812b417749a812fc30b120db5.otf";